import React from 'react'

import { connect } from 'react-redux'

import SelectSearchContainer from '../SelectSearchContainer'
import Loading from '../Loading'

import { getBrokeragesIsLoading, getFilteredBrokerages } from './selectors'
import { fetchBrokerages } from '../../../brokerages/actions'

export class BrokerageSelectSearchContainer extends React.Component {
  componentWillMount() {
    const { isLoading, brokerages, fetchBrokerages } = this.props

    // If brokerages are not already being loaded and there are no
    // brokerages in state, then go fetch the brokerages ourselves.
    if (!isLoading && brokerages.length <= 0) {
      fetchBrokerages()
    }
  }

  render() {
    const {
      isLoading,
      brokerages,
      value,
      onChange,
      id = 'brokerage-select-search-container'
    } = this.props

    if (isLoading) {
      return <Loading width="36px" height="36px" />
    }

    return (
      <SelectSearchContainer
        options={brokerages}
        value={value}
        onChange={onChange}
        id={id}
        labelColumn="name"
        valueColumn="brokerId"
      />
    )
  }
}

const mapStateToProps = state => ({
  brokerages: getFilteredBrokerages(state),
  isLoading: getBrokeragesIsLoading(state),
})

const mapDispatchToProps = {
  fetchBrokerages,
}

export const ConnectedBrokerageSelectSearchContainer = connect(mapStateToProps, mapDispatchToProps)(BrokerageSelectSearchContainer)
